export enum RETORNO_ADS_EVENT_ACTION {
  VIEW = 'visualizacao',
  CLICK = 'clique',
}

export enum RETORNO_ADS_TYPE {
  SEARCH = 'pesquisa',
  CARD = 'card',
}
